import { apiFetch } from './client';

export interface Device {
  device_id: string;
  name: string;
  online: boolean;
  firmware_version?: string;
  last_seen_at?: string;
}

export async function listDevices(): Promise<Device[]> {
  const r = await apiFetch<{ devices: Device[] }>('/v1/devices');
  return r.devices ?? [];
}

export async function renameDevice(id: string, name: string): Promise<void> {
  await apiFetch(`/v1/devices/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
}
